import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        as: 'span',
        padding: `${remCalc(6)} ${remCalc(8)}`,
        textStyle: 'body-xxsmall',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        color: 'text.inverse',
        backgroundColor: 'background.brand',
    },
    variants: {
        light: {color: 'text.primary', backgroundColor: 'background.light-blue'},
        coupon: {
            color: 'text.success',
            backgroundColor: 'background.success',
            fontStyle: 'body-xxsmall',
            fontWeight: '700',
        },
        grey: {color: 'text.secondary', backgroundColor: 'background.grey'},
        error: {color: 'text.danger', backgroundColor: 'background.danger'},
    },
}
